var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22804 7.33333L28.8289 32.3268M3.22804 7.33333C4.18055 6.2459 5.60323 5.55556 7.1927 5.55556H15.8472M3.22804 7.33333C2.46196 8.20793 2 9.3394 2 10.5752V28.9804C2 31.7526 4.32485 34 7.1927 34H26.2326C29.1004 34 31.4253 31.7526 31.4253 28.9804V21.451M15.8472 21.451L4.59635 32.3268M28.1149 7.68889V7.58194M34 7.56522C34 11.2754 28.1149 16.2222 28.1149 16.2222C28.1149 16.2222 22.2299 11.2754 22.2299 7.56522C22.2299 4.49163 24.8647 2 28.1149 2C31.3652 2 34 4.49163 34 7.56522Z",
    stroke: "#2337A9",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/mapPin.53fcf11676306cd089cfe499a1a7c148.svg";
export { ForwardRef as ReactComponent };